import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';


@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  canActivate(): boolean {
    console.log(this.router.url);
    if(this.router.url == '/iniciar'){
      this.router.navigate(['/iniciar'], { replaceUrl: true });
      return false;
    }



    if (this.authenticationService.isAuthenticated()) {
      return true;
    }


    return false;
  }
}
